import { Droplets, TreePine, BookOpen, Store } from "lucide-react";
import { useLang } from "@/lib/i18n";

const TEMPLATES = [
  {
    icon: Droplets, sdg: "SDG 13", title_id: "Bersih Sungai & Bank Sampah", title_en: "River Cleanup & Waste Bank",
    category: "Lingkungan",
    problem: "Bantaran sungai di lingkungan kami dipenuhi sampah plastik dan belum ada sistem bank sampah untuk mengelolanya secara berkelanjutan",
  },
  {
    icon: TreePine, sdg: "SDG 13", title_id: "Tanam Mangrove & Penghijauan Pesisir", title_en: "Coastal Mangrove & Tree Planting",
    category: "Lingkungan",
    problem: "Pesisir di wilayah kami terkikis abrasi dan kehilangan tutupan mangrove sehingga permukiman nelayan terancam",
  },
  {
    icon: BookOpen, sdg: "SDG 4", title_id: "Literasi & Kelas Mengajar Komunitas", title_en: "Community Literacy & Teaching",
    category: "Pendidikan",
    problem: "Anak-anak di kampung kami kesulitan membaca dan tidak memiliki akses taman baca maupun pendamping belajar",
  },
  {
    icon: Store, sdg: "SDG 5", title_id: "UMKM Perempuan & Keterampilan Digital", title_en: "Women Micro-Enterprise & Digital Skills",
    category: "Pemberdayaan",
    problem: "Ibu-ibu pelaku usaha mikro di wilayah kami belum mampu memasarkan produk secara digital sehingga pendapatan stagnan",
  },
];

export default function TemplateLibrary({ onPick }) {
  const { lang, t } = useLang();
  return (
    <div className="mb-6">
      <p className="text-sm font-black text-slate-700 uppercase tracking-wider mb-3">{t("templates_title")}</p>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
        {TEMPLATES.map((tpl, i) => (
          <button
            key={i}
            data-testid={`template-card-${i}`}
            onClick={() => onPick(tpl)}
            className="card-lift text-left bg-white rounded-2xl border border-slate-200 p-4"
          >
            <span className="inline-flex bg-emerald-50 text-emerald-600 rounded-xl p-2 mb-2"><tpl.icon className="w-5 h-5" /></span>
            <p className="font-heading font-extrabold text-sm text-slate-900 leading-snug">{lang === "en" ? tpl.title_en : tpl.title_id}</p>
            <span className="inline-block mt-2 text-[10px] font-black px-2 py-0.5 rounded-full bg-slate-900 text-white">{tpl.sdg}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
